import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { DynReportService, ReportPeriod, Report17A } from '../shared';

import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { Message, SelectItem} from "primeng/primeng";
import { ReportFilter } from 'app/dyn-reports/shared/dyn-report8.model';
//import { SelectItem } from 'primeng/components/common/selectitem';

@Component({
  moduleId: module.id,
  selector: 'bp-dyn-report',
  templateUrl: './dyn-report17A.component.html',
  styleUrls: ['./dyn-report17A.component.css'],
})

export class DynReport17AComponent implements OnDestroy, OnInit {
  //@Input() report: any;
  infos: Message[];
  private dbResetSubscription: Subscription;
  private id: any;
  filter: ReportFilter;
  report: any;
  //periodss: ReportPeriod[];
  selectedPeriod: ReportPeriod;
  selectedYear: SelectItem;
  report17Adata: any;

  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private reportService: DynReportService,
    private toastService: ToastService) { }

  private getYears() {
    this.reportService.getReport17aYears()
      .subscribe(filter => {
        this.filter = filter;
      });
  }

  ngOnInit() {
    //this.route
    //  .params
    //  .map(params => params['id'])
    //  .do(id => this.id = +id)
    //  .subscribe(id => this.getReport());
    this.getYears();
   // this.getPeriods();
    this.report17Adata = {
      labels: [],
      datasets: [
        {
          data: [] = [],
          backgroundColor: [] = []
        }]
    };
  }

  ngOnDestroy() {
    // this.dbResetSubscription.unsubscribe();
  }

  showReport(event: Event) {
    this.getReport(this.selectedPeriod.id);
  }

  private getReport(id: number) {
    //TODO
    //if (this.id === 0) { return; }; //TODO: nece da radi zato sto ima id ===0

    this.reportService.getReport17A(id)
      .subscribe(report => {

        console.log(report);
        this.report = report;

        this.report.data.forEach(label => {
          this.report17Adata.labels.push(label.description);
        });

        let data = [];

        this.report.data.forEach(item => {
          data.push({ data: item });
        });

        this.report17Adata.datasets[0] = this.reportService.setPieChartData(data, 'amount');
      });
  }

  private getPeriods() {
    this.reportService.getReport17aPeriods(this.selectedYear.value)
      .subscribe(filter => {
        if (this.filter) {
          this.filter.periods = filter.periods;
        } else {
          this.filter = filter;
        }
        //console.log('.filter', this.filter);

      });
  }

  private gotoReports() {
    this.router.navigate(['/reports']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }
  reportYearChanged(event: Event) {
    
    this.selectedPeriod = null;
    this.getPeriods();

  }
}



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-report/dyn-report17A.component.ts